import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './ServiceSection.css'; // Standard custom styling loaded here
import ServiceCard from './ServiceCard/ServiceCard';

const servicesListData = [
  {
    id: 1,
    title: 'Featured Profile',
    description: 'Rank higher, plus stand out in search results – the best way to make a mark.',
    features: ['Rank on top of the search results', "Stand out as a 'Featured Profile'"],
    price: '699',
    imageSrc: '/assets/Images/career_solutions/ServiceSection/xpress-resume.svg' ,
    baseLink: "/career-booster"
  },
  {
    id: 2,
    title: 'Career Booster',
    description: 'Boost your job search using Featured Profile & Resume Writing',
    features: ["Rank higher with a 'Featured Profile' in search results", 'Get a competitive edge with a tailored resume'],
    price: '4599',
    imageSrc: '/assets/Images/career_solutions/ServiceSection/career-booster.svg',
    baseLink: "/career-booster"
  },
  {
    id: 3,
    title: 'Profile Highlighter',
    description: 'Get your profile highlighted to ensure immediate attention',
    features: ['Get a highlight added to your profile', 'Be tagged as an active jobseeker'],
    price: '999',
    imageSrc: '/assets/Images/career_solutions/ServiceSection/resume-highlighter.svg',
    baseLink: "/career-booster"
  },
  {
    id: 4,
    title: 'LinkedIn Makeover',
    description: 'Revamp your LinkedIn profile & make it a magnet for job opportunities.',
    features: ['Make your milestones & accomplishments shine through', 'Let your LinkedIn profile amplify/tell your career story.'],
    price: '1999',
    imageSrc: '/assets/Images/career_solutions/ServiceSection/linkedin-makeover.svg',
    baseLink: "/career-booster"
  },
  {
    id: 5,
    title: 'Resume Builder',
    description: 'Create a customised resume for each job application within minutes.',
    features: ['Access 15+ ATS-friendly resume templates', 'Use 400 pre-written resume samples'],
    price: '199',
    imageSrc: '/assets/Images/career_solutions/ServiceSection/resume-builder.svg',
    baseLink: "/career-booster"
  },
  {
    id: 6,
    title: 'Resume Writing',
    description: 'Craft a compelling professional story to put your best foot forward.',
    features: ['Get a resume crafted by experts', 'Rank higher on search with strategic use of keywords'],
    price: '3999',
    imageSrc: '/assets/Images/career_solutions/ServiceSection/right-resume.svg',
    baseLink: "/career-booster"
  }
];

const ServiceSection = () => {
  return (
    <div className="services-showcase-parent">
      <Container  className="">
        <Row className="g-4">
          {servicesListData.map((service) => (
            <Col key={service.id} xl={4} md={6} xs={12}>
              <ServiceCard
              baseLink={service.baseLink}
                title={service.title}
                description={service.description}
                features={service.features}
                price={service.price}
                imageSrc={service.imageSrc}
              />
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default ServiceSection;